import type { Module } from "src/system/module.types.ts";
import { ResourceEnum } from "src/constants/constants.ts";
import React from "react";
import type { CategoryResource } from "@exonn/js-sdk";

export const module: Module = {
  id: ResourceEnum.Category,
  name: (t) => t("moduleName.categories"),
  bigIcon: <i className={"icon-20-categories"} />,
  smallIcon: <i className={"icon-15-categories"} />,

  tabs: {
    edit: {
      getTitle: (resource: CategoryResource) => resource.title,
    },
  },
};
